import * as Preact from 'preact';
import { Box } from '@mui/material';
import * as ModalTitle from './M_ModalTitle';
import * as ModalActionBar from './M_ModalActionBar';
import * as ModalContainer from './A_ModalContainer';
export var Component = function (props) {
    return (Preact.h(ModalContainer.Component, { open: props.open, dialogPadding: props.dialogPadding },
        Preact.h(Box, { sx: {
                display: 'grid',
                gridTemplateAreas: "'title' 'content' 'actionbar' ",
                gridTemplateRows: 'auto 1fr auto',
                height: '100%',
            } },
            Preact.h(ModalTitle.Component, { title: props.title, onCloseClick: props.onCloseClick, sx: { gridArea: 'title' } }),
            Preact.h(Box, { sx: {
                    gridArea: 'content',
                    background: 'white',
                    overflowY: 'auto',
                    maxHeight: props.actionBar ? '364px' : '436px',
                } }, props.children),
            props.actionBar && (Preact.h(ModalActionBar.Component, { primary: props.actionBar.primary, secondary: props.actionBar.secondary, sx: { gridArea: 'actionbar' } })))));
};
Component.displayName = 'Modal';
